<template>
    <div v-if="userDetails?.canShareAccount && summaries.length > 0 && !isViewingAsOther" class="firm-dashboard">
        <h4 class="firm-title">Your team</h4>
        <div v-if="loading" class="firm-loading">Loading team data...</div>
        <div v-else class="firm-cards-scroll">
            <div class="firm-cards">
                <div v-for="member in summaries" :key="member.userId" class="firm-card" @click="viewAs(member)">
                    <div class="firm-card-left">
                        <div class="firm-card-avatar">{{ (member.givenName?.charAt(0) || '') + (member.surname?.charAt(0) || '') }}</div>
                    </div>
                    <div class="firm-card-center">
                        <div class="firm-card-name">{{ member.givenName }} {{ member.surname }}</div>
                        <div class="firm-card-stats">
                            {{ member.clientCount }} {{ member.clientCount === 1 ? 'client' : 'clients' }}
                            &middot;
                            {{ member.analysisCount }} {{ member.analysisCount === 1 ? 'analysis' : 'analyses' }}
                            <span v-if="member.lastAnalysisDate"> &middot; Last: {{ formatDate(member.lastAnalysisDate) }}</span>
                        </div>
                        <div v-if="hasIntegrations(member)" class="firm-card-integrations">
                            <span v-for="(count, name) in member.analysisByIntegration" :key="name" class="integration-badge">{{ formatIntegrationName(name) }}: {{ count }}</span>
                        </div>
                    </div>
                    <div class="firm-card-right">
                        <span class="firm-card-arrow">&#8250;</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.firm-dashboard {
    max-width: 1100px;
    min-width: 1044px;
    width: 100%;
    margin: 24px auto 0 auto;
    background: white;
    border-radius: 8px;
    padding: 16px 24px 18px 24px;
}

.firm-title {
    font-family: 'Inter', sans-serif;
    font-size: 16px;
    font-weight: 700;
    color: #1e228c;
    margin: 0 0 12px 0;
}

.firm-loading, .firm-empty {
    color: #666;
    font-size: 13px;
    padding: 4px 0;
}

.firm-cards-scroll {
    overflow-x: auto;
    scrollbar-width: thin;
    scrollbar-color: #ccc transparent;
}
.firm-cards-scroll::-webkit-scrollbar { height: 5px; }
.firm-cards-scroll::-webkit-scrollbar-thumb { background: #ccc; border-radius: 3px; }

.firm-cards {
    display: flex;
    gap: 10px;
    padding-bottom: 10px;
}

.firm-card {
    display: flex;
    align-items: center;
    gap: 10px;
    background: #F3F2EF;
    border-radius: 8px;
    padding: 10px 14px;
    width: 340px;
    min-width: 340px;
    flex-shrink: 0;
    cursor: pointer;
    transition: background 0.15s;
}
.firm-card:hover {
    background: #ECEAE6;
}

.firm-card-left {
    flex-shrink: 0;
}

.firm-card-avatar {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    background: #353C8E;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    font-size: 12px;
}

.firm-card-center {
    flex: 1;
    min-width: 0;
}

.firm-card-name {
    font-weight: 600;
    font-size: 13px;
    color: #1a1a2e;
}

.firm-card-stats {
    font-size: 11px;
    color: #666;
    margin-top: 1px;
}

.firm-card-integrations {
    display: flex;
    gap: 4px;
    margin-top: 3px;
    flex-wrap: wrap;
}

.integration-badge {
    font-size: 10px;
    color: #555;
    background: #E8E7E3;
    border-radius: 3px;
    padding: 1px 5px;
}

.firm-card-right {
    flex-shrink: 0;
}

.firm-card-arrow {
    font-size: 22px;
    color: #999;
    font-weight: 300;
}
</style>

<script>
import { useViewAs } from '../composables/useViewAs';

export default {
    name: 'FirmDashboard',
    props: ['userDetails'],
    inject: ['AccessService'],
    setup() {
        const { isViewingAsOther, setViewAsUser } = useViewAs()
        return { isViewingAsOther, setViewAsUser }
    },
    computed: {
        summaries() {
            return this.AccessService.getGrantedToMeSummary().value || []
        },
        loading() {
            return this.AccessService.isSummaryLoading().value
        }
    },
    mounted() {
        if (this.userDetails?.canShareAccount && !this.isViewingAsOther) {
            this.AccessService.fetchGrantedToMeSummary()
        }
    },
    methods: {
        viewAs(member) {
            this.setViewAsUser({
                userId: member.userId,
                givenName: member.givenName,
                surname: member.surname
            })
            sessionStorage.setItem('viewAsSwitching', 'true')
            var loadingEl = document.getElementById('app-loading')
            if (loadingEl) loadingEl.style.display = 'flex'
            window.location.href = '/'
        },
        hasIntegrations(member) {
            return member.analysisByIntegration && Object.keys(member.analysisByIntegration).length > 0
        },
        formatIntegrationName(name) {
            if (name === 'IPIPELINE') return 'iPipeline'
            if (name === 'UNDERWRITEME') return 'UnderWriteMe'
            return name
        },
        formatDate(dateStr) {
            if (!dateStr) return ''
            var d = new Date(dateStr)
            return d.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' })
        }
    }
}
</script>
